<template>
  <div class="c_btn"
    :class="{
      'c_btn_loading': loading,
    }"
    role="button"
    :aria-label="this.label"
    tabIndex="0"
  >
    <i class="icon-loading" v-if="loading"></i>
    <span class="update-progress" v-if="type === 'progress'" :class="{'update-progress_show': updating}">
      <div class="icon-refresh"></div>
      <div class="num">
        <!-- {{progress}} -->
      </div>
    </span>
    <div class="update-wave" v-if="type === 'progress'"  :class="{'update-wave_show': updating}" :style="`transform: translate(0, -${progress});`">
    </div>
    <template >
      {{label}}
    </template>
  </div>
</template>
<script>
export default {
  props: {
    label: String,
    progress: String,
    loading: {
      type: Boolean,
      default: false,
    },
    updating: {
      type: Boolean,
      default: false,
    },
    type: String,
  },
  computed: {
  },
}
</script>

<style lang="scss" scoped>
@import '~@/scss/animation.scss';

.c_btn{
    width: 22px;
    height: 18px;
    background: rgb(235, 235, 235);
    border-radius: 2px;
    text-align: center;
    line-height: 18px;
    font-size: 12px;
    float: right;
    color: #7B7B7B;
    cursor: pointer;
    &:hover{
      background: rgb(217, 217, 217);
    }

}

.update-progress{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  text-align: center;
  line-height: 22px;
  visibility: hidden;
  opacity: 0;
  transition: 0.2s ease;
  z-index: 2;
  color: #7B7B7B;
  .icon-refresh,
  .num{
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .num{
    font-size: 12px;
    z-index: 2;
    transform: scale(0.4);
    color: rgba(123, 123, 123, 0.7);
  }
  .icon-refresh{
    animation: spin 2s infinite linear;
    font-size: 16px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.update-progress_show{
  visibility: visible;
  opacity: 1;
  transition: 0.2s ease;
  .icon-refresh{
    animation: spin 2s infinite linear;
  }
}

.update-wave{
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 100%;
  z-index: 1;
  transition: 0.3s ease;
  visibility: hidden;
  opacity: 0;
  &::before,
  &::after{
      content: "";
      position: absolute;
      width: 44px;
      height: 44px;
      top: 150%;
      left: 50%;
      background-color: rgba(217, 217, 217, .7);
      border-radius: 30%;
      transform: translate(-50%, -70%) rotate(0);
      animation: rotate 6s linear infinite;
      z-index: 10;
  }
  &::after {
      border-radius: 30%;
      background-color: rgba(217, 217, 217, 0.5);
      transform: translate(-50%, -70%) rotate(0);
      animation: rotate 10s linear -5s infinite;
      z-index: 20;
  }
}
@keyframes rotate {
  50% {
      transform: translate(-50%, -73%) rotate(180deg);
  } 100% {
      transform: translate(-50%, -70%) rotate(360deg);
  }
}
.update-wave_show{
  visibility: visible;
  opacity: 1;
}

.c_btn_loading {
    cursor: not-allowed;
    .icon-loading{
      animation: spin 1s infinite linear;
    }
    &:hover{
      background: rgb(235, 235, 235);
    }
    &:before{
      display: none;
    }
}
</style>
